import React, { FC, ReactNode, useCallback } from "react";
import { useNavigate } from "react-router-dom";

const BackButton: FC<{ children?: ReactNode; onClick?: () => void }> = ({ children, onClick }) => {
  const navigate = useNavigate();

  const handleClick = useCallback(() => {
    if (onClick) {
      onClick();
    } else {
      navigate(-1);
    }
  }, [onClick, navigate]);

  return (
    <i className="fa fa-chevron-left pointericon" onClick={handleClick}>
      <span className="paddingleft5">{children || "Back"}</span>
    </i>
  );
};

export default BackButton;
